<script setup lang="ts">
import { useAppStore } from '@/store/app/app'

import type { Category } from '@/types/api/api-v3/category'

type Props = {
  category: Category
  isLandingPage?: boolean
}

const props = defineProps<Props>()

const appStore = useAppStore()

const isActiveCategory = computed(() => {
  return props?.category.slug === appStore.activeCategorySlug
})

const handleClick = () => {
  appStore.goToCategory(props?.category.slug)
}
</script>

<template>
  <a
    class="main-category-link"
    :class="{
      'main-category-link--active': isActiveCategory,
    }"
    itemprop="url"
    @click.prevent="handleClick"
  >
    <the-chip size="sm">
      {{ category.name }}
    </the-chip>
  </a>
</template>

<style lang="scss" scoped>
.main-category-link {
  &--active {
    :deep(.app-chip) {
      color: var(--ui-primary);
      background-color: var(--ui-peach);

      &:hover {
        background-color: var(--ui-peach);
      }
    }
  }
}
</style>
